import { AlertWarningCircleIcon } from '@calendly/ui/components/icons';
import { colorAccentOrangeMedium } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const iconContainerCss = "ix4voh6";
const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
const styledAlertSizeSmallCss = "s1nyd2cc";
const styledAlertCss = "s94fjji";
const StyledAlert = forwardRef((props, ref) => {
  const {
    size,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledAlertCss, {
    [styledAlertSizeSmallCss]: size?.toString() === 'small'
  }, props.className)} />;
});
export const InlineAlert = ({
  children,
  ...props
}) => <StyledAlert {...props}>
    <IconContainer>
      <AlertWarningCircleIcon color={colorAccentOrangeMedium} />
    </IconContainer>
    {children}
  </StyledAlert>;

require("./inline-alert.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./inline-alert.js");